<template>
    <div v-if="props.type == 'default'">
        <footer class="bg-void text-white py-10" style="padding-top: 5rem;">
            <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-6 md:px-20 text-center md:text-left pt-10">
                <div>
                    <h2 class="text-2xl font-bold mb-2">Cervo Digital</h2>
                    <p class="text-sm text-gray-400">
                        {{ translationHandler.translate('development of customized digital solutions focused on real results.', 'ucfirst') }}
                    </p>
                </div>

                <div v-for="(item, index) of footerItens" :key="index">
                    <h3 class="text-lg font-semibold mb-2">{{ translationHandler.translate(item.title, 'ucfirst') }}</h3>
                    <ul class="space-y-1 text-sm text-gray-300">
                        <li v-for="(subItem, subItemIndex) of item.itens" :key="subItemIndex" class="list-item-effect">
                            <a
                                :href="generateHref(subItem)"
                                @click.prevent="goToSection(subItem)" 
                                :class="context.isDarkMode ? 'hover:text-primary-dark-color' : 'hover:text-primary-light-color'"
                                class="relative py-2 px-1 transition-all duration-300 ease-in-out cursor-pointer"
                                rel="noopener"
                            >
                                {{ translationHandler.translate(subItem.title, 'ucfirst') }}
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 class="text-lg font-semibold mb-2">
                        {{ translationHandler.translate('connect', 'ucfirst') }}
                    </h3>
                    <div class="flex space-x-4 justify-center md:justify-start">
                        <a v-for="(socialMedia, index) of socialMediaLists" :key="index" :href="socialMedia.link" :class="socialMedia.link != '' ? '' : 'hidden'"
                            target="_blank" :title="translationHandler.translate(socialMedia.title, 'capitalize')">
                            <i :class="`pi ${socialMedia.icon} hover:text-third-color transition`" rel="noopener"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="mt-20 pt-10 border-t border-gray-700 pt-6 text-center text-sm text-gray-500">
                © 2025 Cervo Digital. {{ translationHandler.translate('all rights reserved.', 'ucfirst') }}
            </div>

            <Transition name="fade">
                <button
                    v-if="showScrollTop"
                    @click="scrollToTop"
                    class="fixed bottom-6 right-6 bg-third-color text-white p-3 rounded-full shadow-lg hover:bg-second-color transition-all z-50"
                    style="height: 45px; width: 45px;"
                >
                    <i class="pi pi-arrow-up text-xl"></i>
                </button>
            </Transition>
        </footer>
    </div>
</template>

<script setup>
import { defineProps, onMounted, onUnmounted, ref } from 'vue';
import translationHandler from '@/composables/handlers/TranslationHandler';
import { useContextStore } from '@/stores/context';
import urlHandler from '@/composables/urlHandler';

const context = useContextStore();
const showScrollTop = ref(false);
const props = defineProps({
    type: {
        type: String,
        default: 'default',
    }
});

const socialMediaLists = ref([
    { link: 'https://api.whatsapp.com/send?text=Olá&phone=45991499483', icon: 'pi-whatsapp', title: "access whatsapp" },
    { link: 'https://www.facebook.com/cervo.digital', icon: 'pi-facebook', title: "access facebook" },
    { link: 'https://www.instagram.com/cervodigital_/', icon: 'pi-instagram', title: "access instagram" },
    { link: 'https://www.youtube.com/@CodigoPraticoOficial', icon: 'pi-youtube', title: "access youtube" },
]);

const footerItens = ref([
    {
        title: 'Institucional',
        itens: [
            { link: '/about', title: 'about us'},
            { link: '/budget', title: 'budget', redirect: true },
            { link: '/contact', title: 'contact' },
        ]
    },
    {
        title: 'Informations',
        itens: [
            { link: '/privacypolicy', title: 'policy privacy', redirect: true },
        ]
    }
]);

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
});

function handleScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop
    const halfPage = document.body.scrollHeight / 2
    showScrollTop.value = scrollY > halfPage
}

function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

function goToSection(item) {
    if (item?.redirect) {
        urlHandler.redirect(item.link);
    } else {
        urlHandler.redirect({
            name: '', 
            query: {
                section: `${item.link.replace('/', '')}-section`
            }
        });
    }
}

function generateHref(item) {
    if (item?.redirect) {
        return item.link;
    }

    return `${item.link}`;
}
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
</style>